import type { SalesChecklistItem } from "@expert/contentful";

/**
 * Whether a checklist item has any text to show. `ChecklistItem` renders `null` when this is false,
 * and `getCompletableItems` excludes the item for exactly that reason — a bullet that never renders
 * can never be detected. Both call this so the two cannot drift apart when a new copy field is added.
 */
export const hasRenderableText = (
    item: Pick<SalesChecklistItem, "phrase" | "richPhrase" | "subheading" | "subfooter">,
): boolean => Boolean(item.phrase || item.richPhrase || item.subheading || item.subfooter);
